import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";
import { useAuth } from "../context/AuthContext";

const links = [
  { to: "/", label: "Home" },
  { to: "/venues", label: "Venues" },
  { to: "/venues?type=hotel", label: "Hotels" },
  { to: "/venues?type=wedding-hall", label: "Halls" },
];

export default function Navbar() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const dashboard =
    user?.role === "admin" ? "/admin" : user?.role === "owner" ? "/owner" : null;

  return (
    <header className="sticky top-0 z-40 border-b border-white/40 bg-cream/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6 lg:px-8">
        <Logo />
        <nav className="hidden items-center gap-7 md:flex">
          {links.map((link) => (
            <NavLink
              key={link.label}
              to={link.to}
              end={link.to === "/"}
              className={({ isActive }) =>
                `text-sm font-medium transition ${
                  isActive ? "text-rose" : "text-ink/70 hover:text-ink"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden items-center gap-3 md:flex">
          {user ? (
            <>
              <Link to={dashboard} className="btn-ghost">
                {user.role === "admin" ? "Admin" : "My venue"}
              </Link>
              <button
                className="btn-ink"
                onClick={() => {
                  logout();
                  navigate("/");
                }}
              >
                Sign out
              </button>
            </>
          ) : (
            <Link to="/login" className="btn-gold">
              Sign in
            </Link>
          )}
        </div>
        <button
          className="grid h-11 w-11 place-items-center rounded-2xl border border-ink/10 bg-white md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>
      {open && (
        <div className="border-t border-ink/5 bg-cream px-4 py-4 md:hidden">
          <div className="flex flex-col gap-3">
            {links.map((link) => (
              <Link
                key={link.label}
                to={link.to}
                onClick={() => setOpen(false)}
                className="rounded-2xl px-3 py-2 text-sm font-medium text-ink/80 hover:bg-white"
              >
                {link.label}
              </Link>
            ))}
            {user ? (
              <>
                <Link to={dashboard} onClick={() => setOpen(false)} className="btn-ghost">
                  Dashboard
                </Link>
                <button
                  className="btn-ink"
                  onClick={() => {
                    logout();
                    setOpen(false);
                    navigate("/");
                  }}
                >
                  Sign out
                </button>
              </>
            ) : (
              <Link to="/login" onClick={() => setOpen(false)} className="btn-gold">
                Sign in
              </Link>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
